export default {
  data () {
    return {
      currentIndex: null
    }
  },

  methods: {
    openSidebar (index) {
      this.currentIndex = index
    },

    closeSidebar (index) {
      this.currentIndex = null
    }
  }
}
